<template>
  <div class="news_fullScreen_div"
       v-if="newsData.title1 === '' && newsData.info1 === ''">
    <img class="news_fullScreen_img" :src="imgUrl(this.newsData.image1_vollbild)"/>
  </div>
  <div class="news_vertical_horizontal_div"
       v-else :style="{flexDirection: this.displayVertically ? 'column' : 'row',
height: this.displayVertically ? '100%' : '50%',
width: this.displayVertically ? '50%' : '100%'}">
    <img v-if="this.displayVertically && this.newsData.image1_vertikal !== ''" class="news_vertical_img" :src="imgUrl(this.newsData.image1_vertikal)"/>
    <div v-else-if="this.displayVertically && this.newsData.image1_vertikal === ''" :style="{display: none}"> </div>
    <div v-else
         class="news_horizontal_div">
      <img class="news_horizontal_img" :src="imgUrl(this.newsData.image1_horizontal)"/>
    </div>
    <div v-if="this.displayVertically" class="news-content-vertical">
      <div class="news-title" :style="{ color: getTextColor() }"><b>{{ newsData.title1 }}</b></div>
      <div class="news-info" :style="{ color: getTextColor() }" v-html="newsData.info1"></div>
    </div>
    <div v-else class="news-content-horizontal">
      <div class="news-title" :style="{ color: getTextColor() }"><b>{{ newsData.title1 }}</b></div>
      <div class="news-info" :style="{ color: getTextColor() }" v-html="newsData.info1"></div>
    </div>
  </div>
  <div class="news_fullScreen_div"
       v-if="newsData.title2 === '' && newsData.info2 === ''">
    <img class="news_fullScreen_img" :src="imgUrl(this.newsData.image2_vollbild)"/>
  </div>
  <div class="news_vertical_horizontal_div"
       v-else :style="{flexDirection: this.displayVertically ? 'column' : 'row',
height: this.displayVertically ? '100%' : '50%',
width: this.displayVertically ? '50%' : '100%'}">
    <img v-if="this.displayVertically" class="news_vertical_img" :src="imgUrl(this.newsData.image2_vertikal)"/>
    <div v-else class="news_horizontal_div">
      <img class="news_horizontal_img" :src="imgUrl(this.newsData.image2_horizontal)"/>
    </div>
    <div v-if="this.displayVertically" class="news-content-vertical">
      <div class="news-title" :style="{ color: getTextColor() }"><b>{{ newsData.title2 }}</b></div>
      <div class="news-info" :style="{ color: getTextColor() }" v-html="newsData.info2"></div>
    </div>
    <div v-else class="news-content-horizontal">
      <div class="news-title" :style="{ color: getTextColor() }"><b>{{ newsData.title2 }}</b></div>
      <div class="news-info" :style="{ color: getTextColor() }" v-html="newsData.info2"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newsData: {
      type: Object,
      required: true,
    },
    displayVertically: {
      type: Boolean,
      required: true,
    },
    settingData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    imgUrl(image) {
      return 'https://infoboard.samc.at' + image;
    },
    getTextColor() {
      return this.settingData.schema === 'blau' ? '#246591' : '#006666';
    },
  },
}
</script>


<style>

.news-content-horizontal {
  display: flex;
  height: 100%;
  width: 61.5%;
  flex-direction: column;
  overflow: hidden;
  padding-right: 1%;
}

.news-content-vertical {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  padding-right: 1%;
}

.news-title {
  font-size: 2vh;
  padding-left: 2%;
  padding-top: 1%;
  display: flex;
  flex-direction: row;
}

.news-info {
  font-size: 1.2vh;
  padding-left: 2%;
  padding-top: 0;
  display: flex;
  flex-direction: column;
}

.news-info p {
  margin-bottom: 0.5vh;
  margin-top: 0.5vh;
}

#seperator-line-vertically {
  background-color: #ccc;
  width: 2px;
  height: 100%;
  align-self: center;
}

.news_fullScreen_div {
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.news_fullScreen_img {
  height: 98%;
  width: auto;
  margin: 1%;
}

.news_vertical_horizontal_div {

  display: flex;
}

.news_vertical_img {
  height: fit-content;
  width: 98%;
  margin: 1%;
}

.news_horizontal_div {
  height: 100%;
  width: 37.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.news_horizontal_img {
  height: 97%;
  width: auto;
  max-width: 97%;
  max-height: 95%;
  border-radius: 0.5vh;
}
</style>

